import { styled } from "styled-components";

export const SignUpModalBtn = styled.button`
  font-size: 24px;
  color: white;

  background-color: #383838;

  width: 125px;
  height: 40px;
  border: 1px solid #383838;
  border-radius: 30px;
  margin-top: 32px;

  &:hover {
    background-color: #808080;
    border: 1px solid #808080;
  }
`;
